import Services from '../../utils/Services';
import { ExecutionExport } from '../../utils/Constants';
import { t } from '../../i18n/t';
import MAuth from '../../models/MAuth';
import Notification from '../../utils/Notification';
import Apis from '../../utils/Apis';
import Helper from '../../utils/Helper';

export const DownloadCombinedPdf = {

  startDownload(executionOrders, projectId) {
    // plus 1 to prevent the gap between toastr export and send email toastr
    Notification.pushInfo(t('wait_for_export'), ExecutionExport.TOTAL_DURATION + 1);
    Services.checkCombinedPdfExported(projectId, executionOrders).then(
      (isExistedFile) => {
        if (isExistedFile) {
          this.downloadCombinedPdf(projectId, executionOrders);
        } else {
          this.createQueue(executionOrders, projectId)
            .then(() => this.checkExportedFileInterval(executionOrders, projectId));
        }
      }
    );
  },

  createQueue(executionOrders, projectId) {
    return Services.enqueueCombinedPdf(projectId, executionOrders);
  },

  checkExistedFile(projectId, executionOrders) {
    return Services.checkCombinedPdfExported(projectId, executionOrders);
  },

  downloadCombinedPdf(projectId, executionOrders) {
    Notification.remove();
    Helper.download(Apis.downloadCombinedPdf(projectId, executionOrders));
    this.isDownloading = false;
  },

  checkExportedFileInterval(executionOrders, projectId) {
    let count = 0;
    let isCompleted = false;
    const times = ExecutionExport.TOTAL_DURATION / ExecutionExport.ONE_PING;
    const checking = setInterval(() => {
      if (isCompleted) {
        return;
      }
      
      this.checkExistedFile(projectId, executionOrders)
        .then((isExistedFile) => {
          if (isCompleted) {
            return;
          }
          
          if (isExistedFile) {
            isCompleted = true;
            clearInterval(checking);
            this.downloadCombinedPdf(projectId, executionOrders);
          } else {
            count++;
            if (count >= times) {
              isCompleted = true;
              this.sendCombinedPdfEmail(executionOrders, projectId);
              clearInterval(checking);
            }
          }
        });
    }, ExecutionExport.ONE_PING);
  },

  sendCombinedPdfEmail(executionOrders, projectId) {
    Notification.remove();
    Notification.pushInfo(t('send_mail_for_export', { email: MAuth.email }));
    Services.sendCombinedPdfEmail(projectId, executionOrders);
  },
};
